// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#resident-status-tab-component .cancel-btn[data-v-4fa7c3dd],#resident-status-tab-component .update-btn[data-v-4fa7c3dd]{width:120px}#resident-status-tab-component .box-footer[data-v-4fa7c3dd]{padding:10px 0 0 0!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
